<template>
  <div>
    <h1 class="header-tus text-center text-3xl font-bold py-5">Razpoložljivost in kakovost sadja in
      zelenjave</h1>
    <p class="text-center py-5">Prosimo vas, da si vzamete minuto vašega časa in odgovorite na nekaj vprašanj.
      Hvala.</p>
    <SurveyQuestion title="Kako založene so bile police sadja in zelenjave ob vašem obisku?"
              question-more="Kateri sadež ali zelenjavo ste pogrešali?"
              question-more-answer-placeholder="Napišite kateri sadež ali zelenjavo"
              legend-min="Prazne"
              legend-max="Zelo dobro založene"
              @change="questionChanged" question-id="ad2ab09a7ab511ec90d60242ac120003" v-model="q1" :initial-value="initialAnswer"></SurveyQuestion>
    <EmptySpace></EmptySpace>
    <SurveyQuestion title="Kako ste bili zadovoljni s kakovostjo sadja in zelenjave?"
              question-more="Kaj je razlog za vašo oceno?"
              legend-min="Zelo nezadovoljen/-na"
              legend-max="Popolnoma zadovoljen/-na"
              question-more-answer-placeholder="Opišite vaš razlog" @change="questionChanged"
              question-id="46a5e0147ab611ec90d60242ac120003" v-model="q2"></SurveyQuestion>
  </div>
</template>

<script>
import EmptySpace from '@/components/EmptySpace'
import SurveyQuestion from '@/components/SurveyQuestion'
import NPSService from '@/services/nps'

export default {
  name: 'StepQuestions',
  components: { SurveyQuestion, EmptySpace },
  props: {
    flowId: {}
  },
  data () {
    return {
      npsId: '83acc15a7ab411ec90d60242ac120003',
      q1: null,
      q2: null,
    }
  },
  computed: {
    initialAnswer () {
      let parts = window.location.search.split('=')
      if (parts[0] == '?q') {
        return parseInt(parts[1])
      }
      return null
    }
  },
  methods: {
    questionChanged (qId) {
      if (qId.questionId) {
        const npss = new NPSService()
        npss.store(this.npsId, this.flowId, qId.questionId, qId.score, qId.more)
      }
      this.$emit('update:finished', true)
    }
  }
}
</script>

<style scoped>

</style>
